// src/app/(main)/home/page.tsx

import LoginForm from '../../../components/main/LoginForm';

export default function Page() {
  return <LoginForm />;
}
